export default {
    storageConstants: {
        AZURE_TOKEN: "azure.token",
        AZURE_TOKEN_EXP: "azure.expiration_date",
        AWS_ASSERTION: "aws.assertion",
        AWS_SESSION_FOR_ACCOUNT: "aws.session"
    }
}
